import { formComponents as fc } from "@/features/i18n/formComponents";
import { ui } from "@patient-watch/ui";
import { useAddOrganisation } from "@/features/admin/api/addOrganisation";
import { organisationBreadcrumbTrail } from "@/features/admin/constants/organisationNav";
import {
    type OrganisationCodeSchemaType,
    convertOrganisationNameToCode,
    organisationCodeSchema,
} from "@/features/admin/organisations/organisationForm";
import { type SubmitHandler, useForm, useWatch, zodResolver } from "@/utils/form";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

const AddOrganisationForm = () => {
    useNav(organisationBreadcrumbTrail("Add Organisation"));

    const addOrganisation = useAddOrganisation();
    const form = useForm<OrganisationCodeSchemaType>({
        resolver: zodResolver(organisationCodeSchema),
        defaultValues: {
            nhs_flag: false,
        },
    });

    const { control } = form;

    const organisationName = useWatch({
        control: control,
        name: "organisation_name",
    });

    useEffect(() => {
        const newCode = convertOrganisationNameToCode(organisationName);
        if (newCode) form.setValue("organisation_code", newCode);
    }, [organisationName, form]);

    const onSubmit: SubmitHandler<OrganisationCodeSchemaType> = async (formData) => {
        addOrganisation.mutate(formData);
    };

    return (
        <section className="max-w-lg">
            <ui.Form {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)} className="form">
                    <fc.Input label="Organisation Name" name="organisation_name" />
                    <fc.Input label="Organisation Code" name="organisation_code" />
                    <fc.Switch label="NHS Flag" name="nhs_flag" />
                    <fc.SaveButton buttonType="submit" isLoading={addOrganisation.isPending} className="w-auto" />
                </form>
            </ui.Form>
        </section>
    );
};
export const Route = createFileRoute("/_app/admin/organisation/add")({
    component: AddOrganisationForm,
});
